import ApiService from './api.service';

export default class EavService {
    /**
     * Get boolean EAV
     *
     * @returns {boolean} the EAV value
     */
    public static async getBooleanEav(classParent: string, parentId: number, className: string, attributeName: string): Promise<boolean> {
        return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/Eav/boolean/${classParent}/${parentId}/${className}/${attributeName}`)
        .then((response: any) => {
            return response.data as boolean;
        });
    }
}
